/**
 * Route constants
 *
 * Shared between web and mobile for consistency.
 */

export const ROUTES = {
  // Auth
  LOGIN: '/login',

  // Main
  HOME: '/',
  NOTIFICATIONS: '/notifications',
  DASHBOARDS: '/dashboards',
  DASHBOARD_DETAIL: '/dashboards/:id',
  DASHBOARD_EDIT: '/dashboards/:id/edit',
  DEVICES: '/devices',
  DEVICE_DETAIL: '/devices/:id',
  SCENES: '/scenes',
  SCENE_NEW: '/scenes/new',
  SCENE_DETAIL: '/scenes/:id',
  SCENE_HISTORY: '/scenes/:id/history',
  SCENE_REORDER: '/scenes/reorder',
  SENSORS: '/sensors',
  SENSOR_DETAIL: '/sensors/:id',
  SENSORS_BULK_EDIT: '/sensors/bulk-edit',

  // Utilities
  UTILITIES: '/utilities',
  UTILITIES_MANAGE: '/utilities/manage',
  UTILITIES_CATEGORY: '/utilities/:categoryId',

  // Settings
  SETTINGS: '/settings',
  SETTINGS_INTEGRATIONS: '/settings/integrations',
  SETTINGS_SYSTEM: '/settings/system',
  SETTINGS_HOME_LOCATION: '/settings/home-location',
  SETTINGS_HEARTBEATS: '/settings/heartbeats',
  SETTINGS_REGIONAL: '/settings/regional',
  SETTINGS_NOTIFICATIONS: '/settings/notifications',
  SETTINGS_CHANNELS: '/settings/channels',
  SETTINGS_INPUTS: '/settings/inputs',
  SERVER_INFO: '/settings/server-info',
  API_KEYS: '/settings/api-keys',
  LOGS: '/settings/logs',
  UNIT_TYPES: '/settings/unit-types',

  // Integration settings
  EOS_SETTINGS: '/settings/integrations/eos',
  DIRIGERA_SETTINGS: '/settings/integrations/ikea-dirigera',
  HUE_SETTINGS: '/settings/integrations/philips-hue',
  HTTP_SETTINGS: '/settings/integrations/http',
  MATTER_SETTINGS: '/settings/integrations/matter',
  MQTT_SETTINGS: '/settings/integrations/mqtt',
  MQTT_MONITOR: '/settings/integrations/mqtt/monitor',
  SHELLY_SETTINGS: '/settings/integrations/shelly',
  SLIDE_SETTINGS: '/settings/integrations/slide',
  WEBOS_SETTINGS: '/settings/integrations/webos',

  // Virtual devices
  VIRTUAL_DEVICES: '/devices/virtual',

  // Development only
  DESIGN_SYSTEM: '/design',
} as const;

export type Route = (typeof ROUTES)[keyof typeof ROUTES];
